/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanChangeApprovalRequest
 */
export interface PlanChangeApprovalRequest {
    /**
     * プランID
     * "03" -> 月間契約プラン
     * "04" -> 半年間契約プラン
     * "05" -> 年間契約プラン
     * "09" -> ベクトルグループプラン
     * "10" -> 営業案件プラン
     * "11" -> チケット利用プラン
     * これらの時に承認プロセスが必要になる
     * https://prtimes.atlassian.net/browse/PTP-16 ３．承認プロセスの必要なプラン より参照
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    planId: string;
    /**
     * プラン名
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    planName: string;
    /**
     * プログラム名
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    programName: string | null;
    /**
     * プランの開始日
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    planStartDate: string;
    /**
     * プランの終了日
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    planEndDate: string | null;
    /**
     * プログラム開始日
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    programStartDate: string | null;
    /**
     * プログラム終了日
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    programEndDate: string | null;
    /**
     * 料金
     * @type {number}
     * @memberof PlanChangeApprovalRequest
     */
    price: number;
    /**
     * 一括支払いか
     * @type {boolean}
     * @memberof PlanChangeApprovalRequest
     */
    isLumpSumPayment: boolean | null;
    /**
     * 自動更新するか
     * @type {boolean}
     * @memberof PlanChangeApprovalRequest
     */
    isAutoRenewable: boolean | null;
    /**
     * 承認担当者名
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    approverName: string;
    /**
     * 料金ラベル
     * @type {string}
     * @memberof PlanChangeApprovalRequest
     */
    priceLabel: string;
}

export function PlanChangeApprovalRequestFromJSON(json: any): PlanChangeApprovalRequest {
    return PlanChangeApprovalRequestFromJSONTyped(json, false);
}

export function PlanChangeApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanChangeApprovalRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'planId': json['plan_id'],
        'planName': json['plan_name'],
        'programName': json['program_name'],
        'planStartDate': json['plan_start_date'],
        'planEndDate': json['plan_end_date'],
        'programStartDate': json['program_start_date'],
        'programEndDate': json['program_end_date'],
        'price': json['price'],
        'isLumpSumPayment': json['is_lump_sum_payment'],
        'isAutoRenewable': json['is_auto_renewable'],
        'approverName': json['approver_name'],
        'priceLabel': json['price_label'],
    };
}

export function PlanChangeApprovalRequestToJSON(value?: PlanChangeApprovalRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'plan_id': value.planId,
        'plan_name': value.planName,
        'program_name': value.programName,
        'plan_start_date': value.planStartDate,
        'plan_end_date': value.planEndDate,
        'program_start_date': value.programStartDate,
        'program_end_date': value.programEndDate,
        'price': value.price,
        'is_lump_sum_payment': value.isLumpSumPayment,
        'is_auto_renewable': value.isAutoRenewable,
        'approver_name': value.approverName,
        'price_label': value.priceLabel,
    };
}

